import { kyInstance, requestData } from "../../api-config";

import {
  AssistantCreate,
  AssistantDetail,
  AssistantToolSummary,
  AssistantUpdate,
  BehaviorPreset,
  VoiceOption,
} from "@/types/assistants/assistants";
import { AssistantType } from "@/types/enums/assistant-type";

export async function fetchAssistantTools(): Promise<
  AssistantToolSummary[] | null
> {
  return await requestData<AssistantToolSummary[]>(
    "admin/assistants/tools",
    "get",
    {},
    false,
  );
}

export async function fetchBehaviorPresets(): Promise<BehaviorPreset[] | null> {
  return await requestData<BehaviorPreset[]>(
    "admin/assistants/presets",
    "get",
    {},
    false,
  );
}

export async function fetchVoiceOptions(): Promise<VoiceOption[] | null> {
  return await requestData<VoiceOption[]>(
    "admin/assistants/voices",
    "get",
    {},
    false,
  );
}

export async function fetchVoicePreview(
  voiceKey: string,
): Promise<Blob | null> {
  const response = await kyInstance.get(
    `admin/assistants/voices/${encodeURIComponent(voiceKey)}/preview`,
  );
  return await response.blob();
}

export async function fetchAssistant(
  assistantId: string,
): Promise<AssistantDetail | null> {
  return await requestData<AssistantDetail>(
    `admin/assistants/${assistantId}`,
    "get",
    {},
    false,
  );
}

export async function fetchAssistants(
  assistantTypes: AssistantType[] | null = null,
): Promise<AssistantDetail[] | null> {
  return await requestData<AssistantDetail[]>(
    "admin/assistants",
    "get",
    {
      searchParams: { assistantTypes },
    },
    false,
  );
}

export async function createAssistant(
  assistant: AssistantCreate,
): Promise<AssistantDetail | null> {
  return await requestData<AssistantDetail>(
    "admin/assistants",
    "post",
    {
      json: assistant,
    },
    false,
  );
}

export async function updateAssistant(
  assistantId: string,
  assistant: AssistantUpdate,
): Promise<AssistantDetail | null> {
  return await requestData<AssistantDetail>(
    `admin/assistants/${assistantId}`,
    "put",
    {
      json: assistant,
    },
    false,
  );
}

export async function deleteAssistant(
  assistantId: string,
): Promise<boolean | null> {
  return await requestData<boolean>(
    `admin/assistants/${assistantId}`,
    "delete",
    {},
    false,
  );
}
